module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres85u-popup-approve",
      "id": "hres85u-popup-approve",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    ref: "popupApproveModalButton",
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['0']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "desc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.approve.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codappr",
      "name": "desc_codappr"
    }
  }, [_vm._v(_vm._s(_vm.approve.codappr) + " - " + _vm._s(_vm.approve.desc_codappr))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "currentDate",
      "has-error": _vm.errors.has('currentDate')
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:currentDate'),
      expression: "'required|date_format:DD/MM/YYYY|after:currentDate'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteappr",
      "has-error": _vm.errors.has('dteappr')
    },
    model: {
      value: (_vm.approve.dteappr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dteappr", $$v)
      },
      expression: "approve.dteappr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteappr')),
      expression: "errors.has('dteappr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteappr')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "width-75",
    class: {
      'input-error': _vm.errors.has('amtappr')
    },
    attrs: {
      "numLength": 9,
      "decimal": 2,
      "name": "amtappr",
      "data-vv-name": "amtappr"
    },
    model: {
      value: (_vm.approve.amtappr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "amtappr", $$v)
      },
      expression: "approve.amtappr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['60']))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amtappr')),
      expression: "errors.has('amtappr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('amtappr')))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.typepay),
      expression: "approve.typepay"
    }],
    attrs: {
      "type": "radio",
      "name": "typepay",
      "id": "typepay1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.approve.typepay, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.approve, "typepay", "1")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.typepay),
      expression: "approve.typepay"
    }],
    attrs: {
      "type": "radio",
      "name": "typepay",
      "id": "typepay2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.approve.typepay, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.approve, "typepay", "2")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['90']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateTypepay1, '|date_format:DD/MM/YYYY'),
      expression: "validateTypepay1,'|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "disabled": _vm.disabledDtepay,
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dtepay",
      "name": _vm.boxType
    },
    model: {
      value: (_vm.approve.dtepay),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dtepay", $$v)
      },
      expression: "approve.dtepay"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtepay')),
      expression: "errors.has('dtepay')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtepay')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "status",
      "name": "status"
    }
  }, [_vm._v(_vm._s(_vm.approve.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC2']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.remark),
      expression: "approve.remark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:500'),
      expression: "'max:500'"
    }],
    staticClass: "textarea-text width-70",
    attrs: {
      "id": "remark",
      "maxlength": "500",
      "data-vv-name": "remark",
      "has-error": _vm.errors.has('remark')
    },
    domProps: {
      "value": (_vm.approve.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer align-center border-color-skin"
  }, [_c('button', {
    staticClass: "btn bg-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.validatePopupApprove()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['approve']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67f25d87!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres85u/popupApprove.vue
// module id = 3828
// module chunks = 1